// extracted by mini-css-extract-plugin
export default {"dropdownWrapper":"TouchInvestment_dropdownWrapper__NjSB5","dropdown":"TouchInvestment_dropdown__-6FtW"};